import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Styled, Container, Flex } from 'theme-ui'

export default function SpeakerPage({ data }) {
  const speaker = data.speakersYaml
  return (
    <Layout>
      <Container>
        <Styled.h1
          sx={{
            mb: 5,
          }}>
          {speaker.name}
        </Styled.h1>
        <Flex
        sx={{
          mx: -3,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
        <div
          style={{
            maxWidth: '50%',
          }}>
          <Styled.img
            style={{
              maxWidth: '100%'
            }}
            src={speaker.image}
          />
        </div>
        <div
          sx={{
            flex: 'none',
            p: 3,
            width: [ '100%', '50%' ],
          }}>
          <Styled.p
            sx={{
              mb: 2
            }}>
            {speaker.bio}
          </Styled.p>
        </div>
      </Flex>
      </Container>
    </Layout>
  )
}

export const query = graphql`
query($id: String!) {
  speakersYaml(id: { eq: $id }) {
    id
    name
    bio
    image
    company
    twitter
    github
    linkedin
    url
    dontshow
  }
}
`